import axiosClient from '@/api/axiosClient';
import { API_REPORT_OPEN_BOX, API_GET_BOX, API_UPDATE_BOX } from '@/config/paths/API_PATH';

const getReportOpenBox = async (params) => {
  const response = await axiosClient.get(API_REPORT_OPEN_BOX, { params });
  return response.data;
};

const getLuckyBox = async (params) => {
  const response = await axiosClient.get(API_GET_BOX, { params });
  return response.data;
};

const updateLuckyBox = async (data) => {
  const response = await axiosClient.put(API_UPDATE_BOX, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export { getReportOpenBox, getLuckyBox, updateLuckyBox };
